import createIcon from '../../createIcon';

/**
 * @component @name VolumeUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA4Ljk5OTk4VjE1SDdMMTIgMjBWMy45OTk5OEw3IDguOTk5OThIM1pNMTYuNSAxMkMxNi41IDEwLjIzIDE1LjQ4IDguNzA5OTggMTQgNy45Njk5OFYxNi4wMkMxNS40OCAxNS4yOSAxNi41IDEzLjc3IDE2LjUgMTJaTTE0IDMuMjI5OThWNS4yODk5OEMxNi44OSA2LjE0OTk4IDE5IDguODI5OTggMTkgMTJDMTkgMTUuMTcgMTYuODkgMTcuODUgMTQgMTguNzFWMjAuNzdDMTguMDEgMTkuODYgMjEgMTYuMjggMjEgMTJDMjEgNy43MTk5OCAxOC4wMSA0LjEzOTk4IDE0IDMuMjI5OThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VolumeUp = createIcon('VolumeUp', [
  [
    'path',
    {
      d: 'M3 8.99998V15H7L12 20V3.99998L7 8.99998H3ZM16.5 12C16.5 10.23 15.48 8.70998 14 7.96998V16.02C15.48 15.29 16.5 13.77 16.5 12ZM14 3.22998V5.28998C16.89 6.14998 19 8.82998 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.71998 18.01 4.13998 14 3.22998Z',
      key: '1ozziw',
    },
  ],
]);

export default VolumeUp;
